module.exports = __webpack_public_path__ + "img/QuesoGranReservaCasadelCampo.8598291a.jpg";